import React from "react";
import { Box, useTheme } from "@mui/material";

import TallyBrownLogoCropped150 from "../../assets/Tally_Logotype_RGB_Brown_cropped150.png";
import ConversationPanelAnimation from "./ConversationPanelAnimation.tsx";
import SETTINGS from "../../lib/TallyLibrary/constants/configGeneral.json";

interface ConversationPanelAnimationRef {
  start: () => void;
  stop: () => void;
}

interface DesktopLogoConversationPanelProps {
  refAnimation: React.RefObject<ConversationPanelAnimationRef | null>;
}

const DesktopLogoConversationPanel: React.FC<
  DesktopLogoConversationPanelProps
> = ({ refAnimation }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        top: SETTINGS.topMargin,
        right: 0,
      }}
    >
      <Box
        className="logo__dot"
        sx={{
          position: "absolute",
          top: "10px",
          right: "117px",
          width: "7px",
          height: "7px",
          backgroundColor: `${theme.palette.primary.main}`,
          borderRadius: "50%",
          left: "revert",
        }}
      ></Box>
      <ConversationPanelAnimation ref={refAnimation} />
      <Box
        src={TallyBrownLogoCropped150}
        alt="Tally logo"
        component={"img"}
        sx={[
          {
            width: "100px",
            position: "absolute",
            right: "15px",
          },
        ]}
      />
    </Box>
  );
};

export default DesktopLogoConversationPanel;
